document.addEventListener("DOMContentLoaded", () => {
  const policy = document.getElementById("cookie-policy");
  const declineBtn = document.querySelector(".decline-btn");
  const acceptBtn = document.querySelector(".accept-btn");

  if (policy) {
    if (localStorage.getItem("cookiesAccepted") === null) {
      policy.classList.remove("hidden");
    }

    const handleChoice = (accepted) => {
      localStorage.setItem("cookiesAccepted", accepted ? "true" : "false");
      policy.classList.add("hidden");
    };

    if (acceptBtn) {
      acceptBtn.addEventListener("click", () => handleChoice(true));
    }
    if (declineBtn) {
      declineBtn.addEventListener("click", () => handleChoice(false));
    }
  }
});

